import { create } from 'zustand';

export interface DesignerEditorOptions {
  /** Raw folder path — set by useOpenAppModal */
  currentPath?: string | null;
  /** Filtered params (path + teamId) — set by DesignerEditorDialog */
  params?: Record<string, string>;
  /** Called on save — set by DesignerEditorDialog (includes refetch) */
  onSave?: (assetId: string) => void;
  /** Called on close — set by DesignerEditorDialog (includes closeEditor) */
  onClose?: () => void;
}

interface DesignerEditorState {
  isOpen: boolean;
  options: DesignerEditorOptions;
  /** Tracks Designer iframe dirty state — set by DesignerPage via bridge */
  isDirty: boolean;
  /** Unsaved changes blocker — set by DesignerEditorDialog's handleOpenChange */
  isUnsavedBlocked: boolean;

  openEditor: (options?: DesignerEditorOptions) => void;
  closeEditor: () => void;
  setDirty: (dirty: boolean) => void;
  setUnsavedBlocked: (blocked: boolean) => void;
}

export const useDesignerEditorStore = create<DesignerEditorState>((set) => ({
  isOpen: false,
  options: {},
  isDirty: false,
  isUnsavedBlocked: false,

  openEditor: (options = {}) =>
    set({ isOpen: true, options, isDirty: false, isUnsavedBlocked: false }),
  closeEditor: () => set({ isOpen: false, options: {}, isDirty: false, isUnsavedBlocked: false }),
  setDirty: (isDirty) => set({ isDirty }),
  setUnsavedBlocked: (isUnsavedBlocked) => set({ isUnsavedBlocked }),
}));
